import { useState } from "react";
import { useSelector } from "react-redux";
import { appState } from "$store";
import { IBadgeStatus } from "$components/JBadge/JBadge";
import { useStyles } from "$containers/Receptions/ReceptionList/styles";
import { OrderStatus, SuborderType } from "$types";

export interface ISuborderProduct {
  reference: string;
  quantity: number;
  name: string;
  unit: number;
  deliveryDate?: string;
  status: OrderStatus;
}
export interface ISuborder {
  reference: string;
  type: SuborderType;
  dockyard?: string;
  project?: string;
  subordersProducts: ISuborderProduct;
}
export interface IOrder {
  reference: string;
  company: string;
  orderDate: string;
  provider: string;
  supply: string;
  status: OrderStatus;
  warehouse: string;
  files: any;
  suborders: ISuborder;
}

export interface IReception {
  reference: string;
  receptionDate: string;
  company: string;
  warehouse: string;
  warehouseReference: string;
  provider: string;
  status: "in_progress" | "done";
  orders: Array<IOrder>;
  files: any;
}

export const STATUS_RECEPTION: IBadgeStatus = {
  in_progress: "A traiter",
  canceled: "",
  delivered_incomplete: "",
  done: "Traitée",
  delivered_ok: "",
  new: "Nouveau",
  to_delivered: "En cours",
};

export const STATUS_PRODUCT: IBadgeStatus = {
  in_progress: "En cours",
  canceled: "Annulée",
  delivered_incomplete: "Livré partiel",
  done: "",
  delivered_ok: "Livré total",
  new: "Nouveau",
  to_delivered: "En cours",
};

export interface IReceptionsProps extends IReception {
  className?: string;
}

const useReception = () => {
  const { filter } = useSelector(appState);
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);
  const [referencingOpen, setReferencingOpen] = useState<boolean>(false);
  const [focusedReceptionReferenceId, setFocusedReceptionReferenceId] =
    useState<number | undefined>(undefined);
  const [dateStart_tfilter, setDateStart_tfilter] = useState<
    Date | undefined | null
  >(null);
  const [dateEnd_tfilter, setDateEnd_tfilter] = useState<
    Date | undefined | null
  >(null);

  const togglePopin = (isOpen: boolean) => {
    setOpen(isOpen);
  };

  const toggleReferencingPopin = (isOpen: boolean, focusedId?: number) => {
    setReferencingOpen(isOpen);
    // Set the focused ID when opening, clear it when closing
    if (isOpen && focusedId !== undefined) {
      setFocusedReceptionReferenceId(focusedId);
    } else if (!isOpen) {
      setFocusedReceptionReferenceId(undefined);
    }
  };

  return {
    classes,
    togglePopin,
    open,
    filter,
    dateStart_tfilter,
    setDateStart_tfilter,
    dateEnd_tfilter,
    setDateEnd_tfilter,
    toggleReferencingPopin,
    referencingOpen,
    focusedReceptionReferenceId,
  };
};

export default useReception;
